export default __webpack_public_path__ + "static/media/March2018.c012df44.png";